import { compose } from 'redux'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import { withHandlers, lifecycle, branch } from 'recompose'
import withType from 'components/common/hoc/withType'
import {
  STORE_EMAIL,
  LINK_DATA_ATTRIBUTE_NAME,
  PDF_APPLICATION,
  THIRD_PARTY_URL,
  PREDICTIVE_PROFILES
} from '../constants'
import { getEmptyPDFText } from '../helpers'
import { showStoreLocatorModal } from 'actions/storeLocator'
import Teaser from './Teaser'

const withHandleLinkClick = withHandlers({
  onClick: ({ showStoreLocatorModal }) => e => {
    e.preventDefault()
    if (e.target.getAttribute('data-action') === LINK_DATA_ATTRIBUTE_NAME) {
      showStoreLocatorModal()
    }
  }
})

const withshowStoreLocatorModal = branch(
  ({ localStoreOpportunitiesMode, hasSelectedStore }) => localStoreOpportunitiesMode === null || !hasSelectedStore,
  withHandleLinkClick
)

const withLifecycle = lifecycle({
  componentDidMount() {
    const {
      localStoreOpportunitiesMode,
      hasResourceUrl,
      resourceUrl,
      url,
      storeEmail
    } = this.props

    // eslint-disable-next-line
    const element = findDOMNode(this).querySelector(`[data-action="${LINK_DATA_ATTRIBUTE_NAME}"]`)
    if (localStoreOpportunitiesMode) element.href = url
    element.innerText = localStoreOpportunitiesMode === STORE_EMAIL ? resourceUrl :
      localStoreOpportunitiesMode === PDF_APPLICATION && !hasResourceUrl ?
        getEmptyPDFText({ email: storeEmail }) : element.innerText
  },
  componentDidUpdate(prevProps) {
    const {
      localStoreOpportunitiesMode,
      hasResourceUrl,
      resourceUrl,
      url,
      storeEmail
    } = this.props

    if (prevProps.resourceUrl !== resourceUrl || prevProps.url !== url || prevProps.storeEmail !== storeEmail) {
      // eslint-disable-next-line
      const element = findDOMNode(this).querySelector(`[data-action="${LINK_DATA_ATTRIBUTE_NAME}"]`)
      if (localStoreOpportunitiesMode) element.href = url
      element.innerText = localStoreOpportunitiesMode === STORE_EMAIL ? resourceUrl :
        localStoreOpportunitiesMode === PDF_APPLICATION && !hasResourceUrl ?
          getEmptyPDFText({ email: storeEmail }) : element.innerText
    }
  }
})

const mapStateToProps = (state, {
  localStoreOpportunitiesMode,
  thirdPartyLink,
  predictiveProfilesLink,
  pdfApplicationLink,
  storeEmailLink,
  noStoreLink
}) => {
  const contents = {
    [THIRD_PARTY_URL]: thirdPartyLink,
    [PREDICTIVE_PROFILES]: predictiveProfilesLink,
    [PDF_APPLICATION]: pdfApplicationLink,
    [STORE_EMAIL]: storeEmailLink
  }
  return {
    content: localStoreOpportunitiesMode ?
      contents[localStoreOpportunitiesMode] : noStoreLink
  }
}

export default compose(
  withType({
    type: 'BOTLocationOpportunitiesTeaser'
  }),
  connect(mapStateToProps, { showStoreLocatorModal }),
  withshowStoreLocatorModal,
  withLifecycle
)(Teaser)
